@if (
	showOnlyRecordedScenarios()
		? session().state === SessionState.Finished || session().state === SessionState.Running || session().state === SessionState.Paused
		: hideDraftSessions()
			? session().state !== SessionState.Draft
			: true
) {
	<div
		[@zoomInOnEnter]
		[class.usedWithinEventSelection]="usedWithinEventSelection()"
		[class.schedulingConflict]="session().externalReference?.unresolvedConflicts?.length > 0"
		class="session {{ SessionState[session().state] }}"
		role="region"
	>
		<div class="title">
			<div class="sessionTitleCon nomargin">
				<div class="sessionIcon">
					<mat-icon fontIcon="fa-cube" fontSet="fad" />
				</div>
				<h3 class="mat-h2 sessionTitle nomargin">
					{{ session()?.title }}
				</h3>
			</div>
			@if (session()) {
				<div class="sessionState">
					{{ session().state | getTrainingSessionStateStringForCustomer }}
					<div class="sessionStateIcon">
						@if (showLoadingSpinnerOnScheduledSession() && session().state === SessionState.Scheduled) {
							<i class="fad fa-spinner-third fa-spin fa-5x"></i>
						}
						<ng-container>
							@switch (session().state) {
								@case (SessionState.Stopped) {
									<i class="fad fa-check fa-3x"></i>
								}
								@case (SessionState.Paused) {
									<i class="fad fa-hourglass-start fa-3x"></i>
								}
								@case (SessionState.Scheduled) {
									<i [class.posAbsolute]="showLoadingSpinnerOnScheduledSession()" class="fad fa-clock fa-3x"></i>
								}
								@case (SessionState.Finished) {
									<i [class.posAbsolute]="showLoadingSpinnerOnScheduledSession()" class="fad fa-check fa-3x"></i>
								}
								@default {
									<i class="fad fa-hourglass-start fa-3x"></i>
								}
							}
						</ng-container>
					</div>
				</div>
			}
		</div>
		<div class="location">
			<div class="description">
				{{ T.SHARED_EVENT_SESSION_ROOMS | translate }}
			</div>
			@if (session()) {
				<div class="value sessionTrainingRooms">
					@for (trainingRoomId of session()?.reservedRoomIds; track trainingRoomId) {
						@let trainingRoom = trainingRoomId | getTrainingRoomById | async;
						<div class="trainingRoomLink showDotsOnOverflow">
							<a (click)="showDetailRoom(trainingRoom)" class="clickable">{{ trainingRoom?.name }}</a>
						</div>
					}
					@if (session()?.reservedRoomIds?.length === 0) {
						{{ T.SHARED_EVENT_SESSION_NO_ROOM_SELECTED | translate }}
					}
				</div>
			}
		</div>
		@if (session().type === SessionType.TeamTrainingSession) {
			<div class="location">
				<div class="description">
					{{ T.SHARED_EVENT_SESSION_DEBRIEFING_ROOMS | translate }}
				</div>
				@if (session()) {
					<div class="value sessionTrainingRooms">
						@for (trainingRoomId of session()?.planedDebriefingRoomIds; track trainingRoomId) {
							@let trainingRoom = trainingRoomId | getTrainingRoomById | async;
							<div class="trainingRoomLink showDotsOnOverflow">
								<a (click)="showDetailRoom(trainingRoom)" class="clickable">{{ trainingRoom?.name }}</a>
							</div>
						}
						@if (session()?.planedDebriefingRoomIds?.length === 0) {
							{{ T.SHARED_EVENT_SESSION_NO_ROOM_SELECTED | translate }}
						}
					</div>
				}
			</div>
		}
		<div class="location">
			<div class="description">
				{{ T.SHARED_EVENT_SESSION_LIVE_STREAM_ROOMS | translate }}
			</div>
			@if (session()) {
				<div class="value sessionTrainingRooms">
					@for (trainingRoomId of session()?.planedLiveStreamRoomIds; track trainingRoomId) {
						@let trainingRoom = trainingRoomId | getTrainingRoomById | async;
						<div class="trainingRoomLink showDotsOnOverflow">
							<a (click)="showDetailRoom(trainingRoom)" class="clickable">{{ trainingRoom?.name }}</a>
						</div>
					}
					@if (session()?.planedLiveStreamRoomIds?.length === 0) {
						{{ T.SHARED_EVENT_SESSION_NO_ROOM_SELECTED | translate }}
					}
				</div>
			}
		</div>
		<mat-divider />
		@if (session()) {
			<div class="scenarios">
				<div class="value">
					<div class="headers">
						<div class="estimatedTimeHeader">
							@switch (session().state) {
								@case (SessionState.Paused) {
									{{ T.SHARED_EVENT_SESSION_DURATION | translate }}
								}
								@case (SessionState.Stopped) {
									{{ T.SHARED_EVENT_SESSION_DURATION | translate }}
								}
								@default {
									{{ T.SHARED_EVENT_SESSION_ESTIMATED_TIME | translate }}
								}
							}
						</div>
						<div class="scenariosHeader">
							{{ T.SHARED_EVENT_SESSION_SCENARIOS | translate }}
						</div>
						<div class="statusHeader">
							{{ T.SHARED_EVENT_SESSION_STATUS | translate }}
						</div>
					</div>
					<div class="sessionRuns">
						@for (sessionRun of session().scenarioRecordingGroups; track sessionRun; let iSessionRun = $index) {
							@let scenarioRecording = scenarioRecordings[iSessionRun];
							@if (showOnlyRecordedScenarios() ? scenarioRecording?.state === ScenarioRecordingState.Stopped : true) {
								<div
									[style.order]="sessionRun?.plannedStart ? (sessionRun.plannedStart | date: 'HHmm' :'': translate.currentLang) : 9999"
									class="sessionRun"
								>
									<ng-container>
										@if (scenarioRecording) {
											<div class="estimatedTimeValue">
												@switch (scenarioRecording?.state) {
													@case (ScenarioRecordingState.Stopped) {
														{{ getRecordingStart(scenarioRecording) | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
														-
														{{ getRecordingEnd(scenarioRecording) | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang}}
													}
													@case (ScenarioRecordingState.Recording) {
														{{ getRecordingStart(scenarioRecording) | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
														-
													}
													@case (ScenarioRecordingState.Prepared) {
														@if (sessionRun.plannedStart && sessionRun.plannedEnd) {
															{{ sessionRun.plannedStart | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
															-
															{{ sessionRun.plannedEnd | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
														}
														@if (!sessionRun.plannedStart && !sessionRun.plannedEnd) {
															{{ T.SHARED_EVENT_SESSION_NOT_SET | translate }}
														}
													}
												}
											</div>
										}
										@if (!scenarioRecording) {
											<div class="estimatedTimeValue">
												@if (sessionRun.plannedStart && sessionRun.plannedEnd) {
													{{ sessionRun.plannedStart | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
													-
													{{ sessionRun.plannedEnd | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
												}
												@if (!sessionRun.plannedStart && !sessionRun.plannedEnd) {
													{{ T.SHARED_EVENT_SESSION_NOT_SET | translate }}
												}
											</div>
										}
										@let scenario = sessionRun.scenarioRecordingsMap[0].scenarioId | getScenarioById | async;
										<div class="scenarioValue showDotsOnOverflow">
											<a
												(click)="openScenarioInformationDialog(scenario, iSessionRun)"
												appStopPropagation
												class="scenarioValueButton showDotsOnOverflow clickable"
											>
												{{ scenario?.name }}
											</a>
										</div>
										@let recordingState = scenarioRecording?.state | getScenarioRecordingStateStringForCustomer;
										<div class="statusValue">
											@switch (scenarioRecording?.state) {
												@case (ScenarioRecordingState.Stopped) {
													@if (!finishedRunsClickable()) {
														<div class="finishedCon finished">
															<i class="fad accent fa-check icon"> </i>
															<div class="text">
																{{ recordingState }}
															</div>
														</div>
													}
													@if (finishedRunsClickable()) {
														<sim-button
															(onClick)="finishedRunClickedEmitter.emit(scenarioRecording.id)"
															[disabled]="!scenarioRecording.isReadyForArchive"
															[icon]="{
																fontSet: 'fad',
																fontIcon: 'fa-play',
															}"
															[label]="getScenarioRecordingProgressText(scenarioRecording)"
															[matTooltipDisabled]="scenarioRecording.isReadyForArchive"
															[matTooltip]="T.RECORDING_NOT_READY_FOR_ARCHIVE | translate"
															color="accent"
															width="fit-content"
														/>
													}
													@if (showRecordingExports()) {
														<button
															(click)="openScenarioRecordingExportDialog(scenarioRecording)"
															[disabled]="!scenarioRecording.isReadyForArchive"
															[matBadge]="scenarioRecording.finishedExportsCount"
															[matTooltip]="T.TOOLTIP_EXPORT_RECORDING"
															class="exportBtn"
															color="accent"
															mat-icon-button
															matBadgeColor="warn"
															matTooltipClass="accent"
														>
															<mat-icon fontIcon="fa-download" fontSet="fad" />
														</button>
													}
												}
												@case (ScenarioRecordingState.Prepared) {
													@if (clientProperties()?.isRecorder && allowedToStartAndEnter && showJoinStartActions) {
														<div (click)="startSessionClicked(iSessionRun)" class="startScenarioCon" mat-ripple>
															<i class="fad fa-play"> </i>
															<div class="text">
																{{ T.EVENT_SESSION_START_SCENARIO_BTN_TEXT | translate }}
															</div>
														</div>
													}
													@if (
														!clientProperties()?.isRecorder || !allowedToStartAndEnter || !showJoinStartActions
													) {
														<div class="finishedCon">
															<i class="fad fa-hourglass icon"> </i>
															<div class="text">
																{{ recordingState }}
															</div>
														</div>
													}
												}
												@case (ScenarioRecordingState.Aborted) {
													<div class="finishedCon warn">
														<i class="fa fa-times warn icon"> </i>
														<div class="text">
															{{ recordingState }}
														</div>
													</div>
												}
												@case (ScenarioRecordingState.Recording) {
													<div
														[matTooltip]="
															(T.RECORDING_MAPPING_ID_RECORDING_BY | translate) +
															' ' +
															(scenarioRecording?.startedByWebRecorderId | getRecordingMappingId | async)
																?.name
														"
														class="finishedCon"
														matTooltipClass="accent"
													>
														<i class="fad fa-circle warn icon"> </i>
														<div class="text">
															{{ recordingState }}
														</div>
													</div>
												}
											}
											@if (!scenarioRecording) {
												<div class="finishedCon">
													<i class="fad fa-hourglass icon"> </i>
													<div class="text">
														{{ T.SHARED_SCENARIO_RECORDING_STATE_PREPARED | translate }}
													</div>
												</div>
											}
										</div>
									</ng-container>
								</div>
							}
						}
					</div>
				</div>
			</div>
		}
		@if (session() && participants?.length > 0) {
			<mat-divider />
		}
		@if (!creationMode()) {
			@if (participants?.length > 0) {
				<div class="participations summary">
					<div class="description">
						{{ T.SHARED_EVENT_SESSION_PARTICIPATIONS | translate }}
					</div>
					<div class="value">
						@if ((participants | filterParticipants: ParticipantType.Instructor | transformParticipantsToSimUsers).length > 0) {
							<div class="participatType">
								<div class="participatTypeDescription">
									{{ T.SHARED_EVENT_SESSION_TRAINER | translate }}
								</div>
								<mat-chip-listbox hideSingleSelectionIndicator>
									@for (
										trainer of participants
											| filterParticipants: ParticipantType.Instructor
											| transformParticipantsToSimUsers;
										track trainer
									) {
										<mat-chip-option
											(click)="openUserCardDialog(trainer)"
											[selectable]="false"
											color="accent"
											highlighted
											selected
										>
											{{ trainer.firstname + " " + trainer.lastname }}
										</mat-chip-option>
									}
								</mat-chip-listbox>
							</div>
						}
						@if ((participants | filterParticipants: ParticipantType.Learner | transformParticipantsToSimUsers).length > 0) {
							<div class="participatType">
								<div class="participatTypeDescription">
									{{ T.SHARED_EVENT_SESSION_LEARNERS | translate }}
								</div>
								<mat-chip-listbox hideSingleSelectionIndicator>
									@for (
										learner of participants
											| filterParticipants: ParticipantType.Learner
											| transformParticipantsToSimUsers;
										track learner
									) {
										<mat-chip-option
											(click)="openUserCardDialog(learner)"
											[selectable]="false"
											color="accent"
											highlighted
											selected
										>
											{{ learner.firstname + " " + learner.lastname }}
										</mat-chip-option>
									}
								</mat-chip-listbox>
							</div>
						}
						@if (
							(participants | filterParticipants: ParticipantType.StandardizedPatient | transformParticipantsToSimUsers)
								.length > 0
						) {
							<div class="participatType">
								<div class="participatTypeDescription">
									{{ T.SHARED_EVENT_SESSION_STANDARDIZED | translate }}
								</div>
								<mat-chip-listbox hideSingleSelectionIndicator>
									@for (
										sp of participants
											| filterParticipants: ParticipantType.StandardizedPatient
											| transformParticipantsToSimUsers;
										track sp
									) {
										<mat-chip-option (click)="openUserCardDialog(sp)" [selectable]="false" color="accent" selected>
											{{ sp.firstname + " " + sp.lastname }}
										</mat-chip-option>
									}
								</mat-chip-listbox>
							</div>
						}
					</div>
				</div>
			}
		}
		@if (creationMode()) {
			@if (session()?.participants?.length > 0) {
				<div class="participations">
					<div class="description">
						{{ T.SHARED_EVENT_SESSION_PARTICIPATIONS | translate }}
					</div>
					<div class="value">
						@if (
							(session().participants | filterParticipants: ParticipantType.Instructor | transformParticipantsToSimUsers)
								.length > 0
						) {
							<div class="participatType">
								<div class="participatTypeDescription">
									{{ T.SHARED_EVENT_SESSION_TRAINER | translate }}
								</div>
								<mat-chip-listbox>
									@for (
										trainer of session().participants
											| filterParticipants: ParticipantType.Instructor
											| transformParticipantsToSimUsers;
										track trainer
									) {
										<mat-chip color="accent" highlighted>
											{{ trainer.firstname + " " + trainer.lastname }}
										</mat-chip>
									}
								</mat-chip-listbox>
							</div>
						}
						@if (
							(session().participants | filterParticipants: ParticipantType.Learner | transformParticipantsToSimUsers)
								.length > 0
						) {
							<div class="participatType">
								<div class="participatTypeDescription">
									{{ T.SHARED_EVENT_SESSION_LEARNERS | translate }}
								</div>
								<mat-chip-listbox>
									@for (
										learner of session().participants
											| filterParticipants: ParticipantType.Learner
											| transformParticipantsToSimUsers;
										track learner
									) {
										<mat-chip color="accent" highlighted>
											{{ learner.firstname + " " + learner.lastname }}
										</mat-chip>
									}
								</mat-chip-listbox>
							</div>
						}
						@if (
							(
								session().participants
								| filterParticipants: ParticipantType.StandardizedPatient
								| transformParticipantsToSimUsers
							).length > 0
						) {
							<div class="participatType">
								<div class="participatTypeDescription">
									{{ T.SHARED_EVENT_SESSION_STANDARDIZED | translate }}
								</div>
								<mat-chip-listbox>
									@for (
										sp of session().participants
											| filterParticipants: ParticipantType.StandardizedPatient
											| transformParticipantsToSimUsers;
										track sp
									) {
										<mat-chip color="accent" highlighted>
											{{ sp.firstname + " " + sp.lastname }}
										</mat-chip>
									}
								</mat-chip-listbox>
							</div>
						}
					</div>
				</div>
			}
		}
		<mat-divider />
		<div appStopPropagation class="actions">
			<ng-content select="[actions]" />
			@if (
				(session().state == SessionState.Draft || session().state == SessionState.Scheduled) &&
				session().externalReference?.unresolvedConflicts?.length > 0
			) {
				<sim-button
					(onClick)="openShowSessionConflictsDialog(session())"
					[icon]="{
						fontSet: 'fad',
						fontIcon: 'fa-calendar-range',
					}"
					[label]="T.TRAINING_SESSION_CONFLICTS_BTN_SHOW | translate"
					[matTooltip]="T.TRAINING_SESSION_CONFLICTS_BTN_SHOW_TOOLTIP | translate"
					[matBadge]="session().externalReference.unresolvedConflicts.length"
					[matBadgeColor]="'warn'"
					color="warn"
					size="small"
				/>
			}
			@if (showRemoveAction()) {
				<button (click)="delete.emit()" color="warn" mat-icon-button>
					<mat-icon fontIcon="fa-trash" fontSet="fas" inline />
				</button>
			}
			@if (showEditAction()) {
				<button (click)="edit.emit()" color="accent" mat-icon-button>
					<mat-icon fontIcon="fa-pencil" fontSet="fas" inline />
				</button>
			}
			@if (showJoinStartActions()) {
				@if ((session().state === SessionState.Paused || session().state === SessionState.Started) && allowedToJoin) {
					<button (click)="joinSession()" color="accent" mat-raised-button>
						{{ T.SHARED_EVENT_SESSION_JOIN_SESSION | translate }}
					</button>
				}
				@if (
					(session().state === SessionState.Running || session().state === SessionState.Scheduled) &&
					allowedToJoin &&
					!allowedToStartAndEnter
				) {
					<button (click)="joinSession()" [disabled]="!sessionStartable()" color="accent" mat-raised-button>
						{{ T.SHARED_EVENT_SESSION_JOIN_SESSION | translate }}
					</button>
				}
				@if (session().state === SessionState.Running && sessionStartable() && allowedToJoinActive && allowedToStartAndEnter) {
					<button (click)="joinActiveSessionClicked()" color="accent" mat-raised-button>
						{{ T.SHARED_EVENT_SESSION_ENTER_SESSION_TEXT | translate }}
					</button>
				}
				@if (
					hasLicenseModule(Modules.EventDesigner) &&
					clientProperties()?.isRecorder &&
					session().state === SessionState.Finished &&
					allowedToStartAndEnter
				) {
					<button (click)="continueFinishedTrainingSession()" color="accent" mat-raised-button>
						{{ T.SHARED_EVENT_SESSION_CONTINUE_TRAINING | translate }}
					</button>
				}
				@if (session().state === SessionState.Scheduled && allowedToStartAndEnter) {
					<button (click)="startSessionAsOwner()" [disabled]="!sessionStartable()" color="accent" mat-raised-button>
						{{ T.EVENT_DETAIL_START_SESSION | translate }}
					</button>
				}
			}
		</div>
	</div>
}
